const storageTypes = {
    local: localStorage,
    session: sessionStorage,
  };

  
const keys = {
    storage: storageTypes.session,
  };

  const appConstants = {
    keys
  }
  
  export default appConstants;
